import React from 'react';
import PropTypes from 'prop-types';

import IntegrationAvatarGroup from 'app/shared/components/integrations/IntegrationAvatarGroup';
import buildBubbleClickProps from 'app/components/data-table/buildBubbleClickProps';

export default function IntegrationsCell({ integrations, bubbleClickEvent }) {
  const imgProps = {
    ...buildBubbleClickProps(bubbleClickEvent),
  };

  return <IntegrationAvatarGroup integrations={integrations} imgProps={imgProps} />;
}

IntegrationsCell.propTypes = {
  integrations: PropTypes.arrayOf(
    PropTypes.shape({
      starterkitId: PropTypes.string.isRequired,
      name: PropTypes.string,
    })
  ),
  bubbleClickEvent: PropTypes.bool,
};
